export default __webpack_public_path__ + "static/media/02_photo.277bacf3.jpeg";